import mapData from './world.geo.json';
// import { Debugout } from 'debugout.js';
// const bugout = new Debugout();

const fectivaMapRawData = `Afghanistan
Alabama
Alaska
Albania
Algeria
American Samoa
Andorra
Angola
Anguilla
Antarctica
Antigua and Barbuda
Argentina
Arizona
Arkansas
Armenia
Aruba
Australia
Austria
Azerbaijan
Bahamas
Bahrain
Bangladesh
Barbados
Belarus
Belgium
Belize
Benin
Bermuda
Bhutan
Bolivia
Bosnia and Herzegovina
Botswana
Bouvet Island
Brazil
British Indian Ocean Territory
British Virgin Islands
Brunei
Bulgaria
Burkina Faso
Burundi
California
Cambodia
Cameroon
Canada
Cape Verde
Cayman Islands
Central African Republic
Chad
Chile
China
Christmas Island
Cocos (Keeling) Islands
Colombia
Colorado
Comoros
Congo Republic
Connecticut
Cook Islands
Costa Rica
Cote d'Ivoire
Croatia
Cuba
Curaçao
Cyprus
Czech Republic
Delaware
Democratic Republic of the Congo
Denmark
Djibouti
Dominica
Dominican Republic
Ecuador
Egypt
El Salvador
Equatorial Guinea
Eritrea
Estonia
Eswatini
Ethiopia
Falkland Islands
Faroe Islands
Fiji
Finland
Florida
France
French Guiana
French Polynesia
Gabon
Gambia
Georgia
Georgia (US)
Germany
Ghana
Gibraltar
Greece
Greenland
Grenada
Guadeloupe
Guam
Guatemala
Guernsey
Guinea
Guinea-Bissau
Guyana
Haiti
Hawaii
Heard and McDonald Islands
Honduras
Hong Kong
Hungary
Iceland
Idaho
Illinois
India
Indiana
Indonesia
Iowa
Iran
Iraq
Ireland
Sint Eustatius
Isle of Man
Israel
Italy
Jamaica
Japan
Jersey
Jordan
Kansas
Kazakhstan
Kentucky
Kenya
Kiribati
Kuwait
Kyrgyzstan
Laos
Latvia
Lebanon
Lesotho
Liberia
Libya
Liechtenstein
Lithuania
Louisiana
Luxembourg
Macau
Madagascar
Maine
Malawi
Malaysia
Maldives
Mali
Malta
Marshall Islands
Martinique
Maryland
Massachusetts
Mauritania
Mauritius
Mayotte
Mexico
Michigan
Micronesia
Minnesota
Mississippi
Missouri
Moldova
Monaco
Mongolia
Montana
Montenegro
Montserrat
Morocco
Mozambique
Myanmar
Namibia
Nauru
Nebraska
Nepal
Netherlands
Nevada
New Caledonia
New Hampshire
New Jersey
New Mexico
New York State
New Zealand
Nicaragua
Niger
Nigeria
Niue
Norfolk Island
North Carolina
North Dakota
North Korea
North Macedonia
Northern Mariana Islands
Norway
Ohio
Oklahoma
Oman
Oregon
Pakistan
Palau
Palestine
Panama
Papua New Guinea
Paraguay
Pennsylvania
Peru
Philippines
Pitcairn
Poland
Portugal
Puerto Rico
Qatar
Reunion
Rhode Island
Romania
Russia
Rwanda
Saint Barthélemy
Saint Lucia
Samoa
San Marino
São Tomé
Sao Tome and Principe
Saudi Arabia
Senegal
Serbia
Seychelles
Sierra Leone
Singapore
Sint Eustatius
Slovakia
Slovenia
Solomon Islands
Somalia
South Africa
South Carolina
South Dakota
South Georgia and South Sandwich Islands
South Korea
Spain
Sri Lanka
St. Helena
St. Kitts and Nevis
St. Maarten
St. Martin
St. Pierre and Miquelon
St. Vincent and the Grenadines
Sudan
Suriname
Svalbard and Jan Mayen Islands
Sweden
Switzerland
Syria
Taiwan
Tajikistan
Tanzania
Tennessee
Texas
Thailand
Timor-Leste
Togo
Tokelau
Tonga
Trinidad and Tobago
Tunisia
Turkey
Turkmenistan
Turks and Caicos Islands
Tuvalu
Uganda
Ukraine
United Arab Emirates
United Kingdom
United States
Uruguay
Utah
Uzbekistan
Vanuatu
Vatican City
Venezuela
Vermont
Vietnam
Virginia
Wallis and Futuna Islands
Washington State
West Virginia
Western Sahara
Wisconsin
Wyoming
Yemen
Zambia
Zimbabwe`;

export function mappingData() {
  mapData.features = mapData.objects.default.geometries;
  const namesInHighCharts = mapData.features.map((m) => m.properties.name);
  const fectivaCountryNames = fectivaMapRawData.split('\n');
  const nameNotInHighChart = fectivaCountryNames.filter(
    (m) => !namesInHighCharts.includes(m),
  );
  console.log(nameNotInHighChart);
}

export function getCodeFromGeo(countryName) {
  // const _tempObj = mapData.features.filter((m) => {
  //   return m.properties.name === countryName;
  // });
  // console.log(_tempObj[0].properties['iso-a3']);
  // const highchartCountries = mapData.features.map((m) => {
  //   return m.properties.name;
  // });
  mapData.features = mapData.objects.default.geometries;
  let code;
  switch (countryName) {
    case 'Anguilla':
    case 'Bermuda':
    case 'Cayman Islands':
    case 'Gibraltar':
    case 'Northern Ireland':
    case 'Scotland':
    case 'Virgin Islands Uk':
    case 'Wales':
    case 'England':
    case 'British Indian Ocean Territory':
    case 'British Virgin Islands':
    case 'Falkland Islands':
    case 'Guernsey':
    case 'Isle of Man':
    case 'Jersey':
    case 'Montserrat':
    case 'Pitcairn':
    case 'South Georgia and South Sandwich Islands':
    case 'St. Helena':
    case 'Turks and Caicos Islands':
      code = 'GBR';
      break;
    case 'Bahamas':
      code = 'BHS';
      break;
    case 'Congo Democratic Rep':
    case 'Congo Republic':
      code = 'COG';
      break;
    case 'Martinique':
    case 'Reunion':
    case 'Guadeloupe':
    case 'French Polynesia':
    case 'French Guiana':
    case 'Mayotte':
    case 'New Caledonia':
    case 'Saint Barthélemy':
    case 'St. Martin':
    case 'St. Pierre and Miquelon':
    case 'Wallis and Futuna Islands"':
      code = 'FRA';
      break;
    case 'Korea Rep Of':
      code = 'KOR';
      break;
    case 'Russian Federation':
      code = 'RUS';
      break;
    case 'Curacao':
    case 'Aruba':
    case 'Curaçao':
    case 'St. Maarten':
    case 'Sint Eustatius':
      code = 'NLD';
      break;
    case 'Macao':
    case 'Macau':
    case 'Hong Kong':
    case 'Taiwan':
      code = 'CHN';
      break;
    case 'Serbia':
      code = 'SRB';
      break;
    case 'St Lucia':
      code = 'LCA';
      break;
    case 'Tanzania':
      code = 'TZA';
      break;
    case 'Trinidad & Tobago':
      code = 'TTO';
      break;
    case 'USA':
    case 'Alabama':
    case 'Alaska':
    case 'Arizona':
    case 'Arkansas':
    case 'California':
    case 'Colorado':
    case 'Connecticut':
    case 'Delaware':
    case 'Florida':
    case 'Georgia (US)':
    case 'Hawaii':
    case 'Idaho':
    case 'Illinois':
    case 'Indiana':
    case 'Iowa':
    case 'Kansas':
    case 'Kentucky':
    case 'Louisiana':
    case 'Maine':
    case 'Maryland':
    case 'Massachusetts':
    case 'Michigan':
    case 'Minnesota':
    case 'Mississippi':
    case 'Missouri':
    case 'Montana':
    case 'Nebraska':
    case 'Nevada':
    case 'New Hampshirea':
    case 'New Jersey':
    case 'New Mexico':
    case 'New York State':
    case 'North Carolina':
    case 'North Dakota':
    case 'Ohio':
    case 'Oklahoma':
    case 'Oregon':
    case 'Pennsylvania':
    case 'Rhode Island':
    case 'South Carolina':
    case 'South Dakota':
    case 'Tennessee':
    case 'Texas':
    case 'United States':
    case 'Utah':
    case 'Vermont':
    case 'Virginia':
    case 'Washington State':
    case 'West Virginia':
    case 'Wisconsin':
    case 'Wyoming':
      code = 'USA';
      break;
    case 'Christmas Island':
    case 'Cocos (Keeling) Islands':
    case 'Svalbard and Jan Mayen Islands':
      code = 'NOR';
      break;
    case 'Bouvet Island':
    case 'Heard and McDonald Islands':
    case 'Norfolk Island':
      code = 'AUS';
      break;
    case 'Cook Islands':
    case 'Niue':
    case 'Tokelau':
      code = 'NZL';
      break;
    case "Cote d'Ivoire":
      code = 'CIV';
      break;
    case 'Eswatini':
      code = 'SWZ';
      break;
    case 'Guinea-Bissau':
      code = 'GNB';
      break;
    case 'Micronesia':
      code = 'FSM';
      break;
    case 'North Macedonia':
      code = 'MKD';
      break;
    case 'Palestine':
      code = 'ISR';
      break;
    case 'São Tomé':
      code = 'STP';
      break;
    case 'St. Kitts and Nevis':
      code = 'KNA';
      break;
    case 'St. Vincent and the Grenadines':
      code = 'VCT';
      break;
    case 'Timor-Leste':
      code = 'TLS';
      break;
    case 'Vatican City':
      code = 'VAT';
      break;
    default:
      code =
        mapData.features.find(
          (feature) => feature.properties.name === countryName,
        )?.properties['iso-a3'] || '';
      break;
  }
  return code;
}
export function getCountryNameFromCode(code) {
  mapData.features = mapData.objects.default.geometries;
  return (
    mapData.features.find((feature) => feature.properties['iso-a3'] === code)
      ?.properties.name || ''
  );
}
function formatNullData(a, b) {
  if (b === null && a === null) {
    return null;
  }
  return a + b;
}
export function combineInfo(infoArr) {
  const infoWithCode = infoArr.map((info) => {
    info.code = getCodeFromGeo(info.countryName);
    return info;
  });
  const res = infoWithCode.reduce((acc, cur) => {
    let flag = false;
    const newAcc = acc.map((item) => {
      if (item.code !== '' && item.code === cur.code) {
        // const combinedItem = {};
        const combinedItem = { ...item };
        combinedItem.companyName = item.companyName;
        combinedItem.countryName = `${item.countryName}/${cur.countryName}`;
        combinedItem.branchesNumber = formatNullData(
          item.branchesNumber,
          cur.branchesNumber,
        );
        combinedItem.employeesNumber = formatNullData(
          item.employeesNumber,
          cur.employeesNumber,
        );
        combinedItem.otherCountries = item.otherCountries.concat(
          cur.otherCountries,
        );
        combinedItem.salesAmount = formatNullData(
          item.salesAmount,
          cur.salesAmount,
        );
        combinedItem.subsidiariesNumber = formatNullData(
          item.subsidiariesNumber,
          cur.subsidiariesNumber,
        );
        combinedItem.code = cur.code;
        flag = true;
        return combinedItem;
      }
      // console.log(item, cur);
      return item;
    });
    if (flag) {
      return newAcc;
    }
    acc.push(cur);
    return acc;
  }, []);
  return res;
}
